import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { EmployeeService } from '../_services';
import * as EmployeeActions from '../_actions/employee';

@Injectable({
  providedIn: 'root',
})
export class EmployeeEffects {
  loadEmployees$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeeActions.loadEmployees),
      mergeMap(() =>
        this.employeeService.getEmployees().pipe(
          map((employees) => EmployeeActions.loadEmployeesSuccess({ employees })),
          catchError((error) => of(EmployeeActions.loadEmployeesFailure({ error })))
        )
      )
    )
  );

  addEmployee$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeeActions.addEmployee),
      mergeMap(({ employee }) =>
        this.employeeService.saveEmployee(employee).pipe(
          map((savedEmployee) => EmployeeActions.addEmployeeSuccess({ employee: savedEmployee })),
          catchError((error) => of(EmployeeActions.addEmployeeFailure({ error })))
        )
      )
    )
  );

  updateEmployee$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeeActions.updateEmployee),
      mergeMap(({ employee }) =>
        this.employeeService.saveEmployee(employee).pipe(
          map((updatedEmployee) =>
            EmployeeActions.updateEmployeeSuccess({ employee: updatedEmployee })
          ),
          catchError((error) => of(EmployeeActions.updateEmployeeFailure({ error })))
        )
      )
    )
  );

  deleteEmployee$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeeActions.deleteEmployee),
      mergeMap(({ id }) =>
        this.employeeService.deleteEmployee(id).pipe(
          map(() => EmployeeActions.deleteEmployeeSuccess({ id })),
          catchError((error) => of(EmployeeActions.deleteEmployeeFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private employeeService: EmployeeService
  ) {}
}
